module.exports = {
    created () {
        $('#view-col').show();
        this.$eventHub.$on('wpr_login', this.wpRemoteLogin);
        this.$eventHub.$on('viewLoader', this.viewLoader);
        this.$eventHub.$on('eventLoader', this.eventLoader);
        this.$eventHub.$on('keepAlive', this.keepAlive);
        this.$eventHub.$on('changeSiteGroup', this.changeSiteGroup);
        if (typeof window.loader != 'undefined' && window.loader != '') {
            this.viewLoader(window.loader);
        }
        this.watchEvents();
        setInterval(() => {
            this.keepAlive();
        }, 3000000);
    },
    data() {
        return {
            checkingKeys: false,
            expandedWPR: false,
            showLoader: false,
            activeUrl: false
        }
    },
    methods: {
        changeSiteGroup(site_id)
        {
            // site/{SITE_ID}/group
            // name
            let params = new URLSearchParams();
            params.append('name', jQuery('#change_wpr_group').val());
            this.axios.post('/wpremote/api/json/site/' + site_id + '/group', params).then((response) => {
                myAlert({ success: 'Group updated. Please refresh.' });
            });
        },
        wpRemoteLogin() {
            this.axios.get('/wpr-login-data').then((response) => {
                if (typeof response.data === 'undefined' || !response.data.success) {
                    myAlert("Sorry there was an error fetching your WP Remote Data");
                    return;
                }

                this.axios.get('/wpremote/api/json/account/login', {
                    params: {
                        data: response.data
                    }
                }).then((response) => {
                    if (typeof window.doFetch === 'function' && window.fetchCount !== 4) {
                        window.fetchCount++;
                        window.doFetch();
                        return;
                    }
                    alert('It appears we have encountered a loop. If this continues, please contact us.');
                    if (typeof response.data['success'] !== 'undefined' && response.data.success) {
                        window.location = '/remote';
                    }
                });
            });
        },
        checkKeys() {
            return;
        },
        keepAlive(callback) {
            this.axios.post('/keep-alive', {
                _token: window.Laravel.csrfToken
            }).then((response) => {
                if (typeof response.data['_token'] !== 'undefined') {
                    fyi('csrfToken Updated');
                    window.Laravel.csrfToken = response.data._token;
                    this.axios.defaults.headers.common = {
                        'X-CSRF-TOKEN': window.Laravel.csrfToken,
                        'X-Requested-With': 'XMLHttpRequest'
                    };
                }
                if (typeof callback !== 'undefined') {
                    callback();
                }
            });
        },
        toggleExpandWPR() {
            $('#main-panels').toggleClass('full-screen');
            $('#sideNavbar').toggle();
            this.expandedWPR = !this.expandedWPR;
        },
        pushFilters(id, filters){
            fyi(id);
            fyi(filters);
            this.$eventHub.$emit(id + 'PushFilters', filters);
        },
        toggleLoader(value) {
            this.showLoader = value;
            if (value) {
                $('#view-col').append('<span id="hiddenLoaderDiv" style="display:none;">&nbsp;</span>');
            } else {
                $('#hiddenLoaderDiv').remove();
            }
        },
        /**
         * Push Events to vue event system to watch for dom updates
         */
        dismiss(name) {
            this.axios.post('/api/dismiss-alert', {
                name: name
            });
            let el = $('#' + name);
            if (el.length) {
                el.hide();
            }
        },
        watchEvents() {
            if (window.currentUser) {
                window.Echo.private(window.IO_CHANNEL)
                    .on('SendEvent', (e) => {
                        // window.rootVue.$eventHub.$emit('')
                        // Loop through each event
                        if (typeof e.data['events'] === 'undefined') return;

                        this.$nextTick(function () { // Runs after content is updated
                            this.pushEvents(e.data.events);
                        });
                    });
            }
        },
        pushEvents(events) {
            if (typeof events === 'undefined') return;

            $.each(events, (key, value) => {
                // If event has a body content
                if (typeof value.body !== 'undefined') {
                    this.$eventHub.$emit(value.name, value.body); // Fire Event
                    return;
                }
                this.$eventHub.$emit(value.name); // Fire Event without body
            });
        },
        /**
         * Send post to update company on remote website
         */
        updateRemoteCompany() {
            this.axios.post('/api/updateRemoteCompany', {
                post_id: this.mainModel.post_id,
                company_id: this.mainModel.company.id
            }).then((response) => {
                if (response.data.success === true) {
                    $('#changeCompanyModal').modal('hide');
                    this.mainModel.obj.company_name(this.mainModel.company.name);
                    this.mainModel.obj.company_id(this.mainModel.company.id);
                    return;
                }
                myAlert({message: 'Sorry there was an error saving the company'});
            }).catch((response) => {
                myAlert({message: 'Sorry there was an error saving the company'});
            });
        },
        toggleArchive(type) {
            this.$eventHub.$emit(type + 'toggleArchive', type);
        },
        setDialog(type, optional){
            this.setCompany = true;
            if (typeof optional !== 'undefined' && typeof optional.use_company !== 'undefined' && !optional.use_company) {
                this.setCompany = false;
            }

            this.$eventHub.$emit('createDialog', type, optional);
            if (typeof optional !== 'undefined' && typeof optional.invoice !== 'undefined') {
                this.$eventHub.$emit('set' + type + 'Invoice', optional.invoice);
            }
        },
        toggleDialog() {
            this.$eventHub.$emit('toggleDialog');
        },
        validateUnsavedChanges() {
            if (window.BOLD.ajaxFormIsChanged) {
                var r = confirm("Unsaved changed, are you sure you wish to continue?");
                if (r != true) {
                    return true;
                }
                window.BOLD.ajaxFormIsChanged = false;
            }
            return false
        },
        /**
         * Load Panel from URL
         * @param url
         * @param event
         */
        viewLoader: function (url, event, urlHistory) {
            if (this.validateUnsavedChanges()) return;
            window.BOLD.ajaxFormIsChanged = false;

            this.activeUrl = url;
            if (typeof event !== 'undefined' && event && (typeof urlHistory === 'undefined' || urlHistory)) {
                let el = $(event.currentTarget);
                $('.ajaxActive').removeClass('ajaxActive');
                if (el.parents('tr').length) {
                    el.parents('tr').addClass('ajaxActive');
                } else {
                    el.addClass('ajaxActive');
                }
                if (el.parents('.link-contain').length) {
                    el.parents('.link-contain').addClass('active');
                }
            }
            // Stop re-loading of existing location
            if (this.currentLocation == url) {
                console.log('Already at location');
                return;
            }
            this.currentLocation = url;

            // Get The URI of the Current URL
            let historyUrl = document.createElement('a');
            historyUrl.href = url;
            historyUrl = historyUrl.pathname.replace('/api', '');
            this.toggleLoader(true);

            this.axios.get(url).then((response) => {
                this.toggleLoader(false);
                let data = response.data;
                document.title = htmlDecode(data.heading);
                if (typeof urlHistory === 'undefined' || urlHistory) {
                    window.history.pushState({
                        responseData: data,
                        "pageTitle": document.title,
                        url: url
                    }, document.title, historyUrl);
                }
                this.$eventHub.$emit('setRightPanel', data); // Fire Event
                // window.Intercom("update");
            });
        },
        /**
         * Load Panel from event
         * TODO : Clean up
         * @param event
         * @returns {boolean}
         */
        eventLoader: function (event) {
            if (this.validateUnsavedChanges()) return false;
            window.BOLD.ajaxFormIsChanged = false;

            let el = $(event.target);

            // Ignore All Clicks if the row is disabled
            if (el.parents('.table-row').hasClass('disabled')) {
                event.preventDefault();
                return false;
            }

            // If Login Link
            if (el.parents('.table-td').hasClass('col-login')) {
                window.open(el.attr('href'), '_blank');
                el = el.parents('.table-row').find('.loadPanel');
                // If element clicked has a href and does not have the class loadPanel
            } else if (event.target.hasAttribute('href') && !el.hasClass('loadPanel') && !el.hasClass('loader') || el.parents('.tr-action').length) {
                return true;
            }

            let urlHistory = true;
            if (el.hasClass('noUrlHistory')) {
                urlHistory = false;
            }

            if (event.currentTarget.hasAttribute('href')) {
                el = $(event.currentTarget);
            } else if (!event.target.hasAttribute('href')) {
                if (event.target.parentElement.tagName === 'TR') {
                    console.log('by TR');
                    el = $(event.target.parentElement.getElementsByClassName("loadPanel")[0])
                } else {
                    // not sure if this even works yo.
                    el = $('.loadPanel:first-child', event.currentTarget);
                    if (!el.length) {
                        return true;
                    }
                }
            }

            if (!el.length || typeof el.attr('href') === 'undefined') {
                el = $('a:first-child', event.currentTarget);
                if (typeof el.attr('href') !== 'undefined') {
                    let target = '_self';
                    if (typeof el.attr('target') !== 'undefined' && el.attr('target') == '_blank') {
                        target = '_blank';
                    }
                    let win = window.open(el.attr('href'), target);
                    win.focus();
                    return;
                }
                console.log('This link has nothing attached. Let it go.');
                return;
            }

            if (el.hasClass('noUrlHistory')) {
                urlHistory = false;
            }

            // == Get the Specifics == //
            let location = el.attr('href');
            // Prevent Tel/Mailto numbers
            if (location.indexOf('tel:') > -1 || location.indexOf('mailto:') > -1) {
                return;
            }

            // Prevent Default Element : If we've made it this far
            event.preventDefault();

            let panel = 'right';
            // Set Panel Location : default 'right'
            if (typeof el.attr('panel') !== 'undefined') {
                panel = el.attr('panel');
            }

            if (panel == 'modal') return;

            $('.ajaxActive').removeClass('ajaxActive');
            $('.link-contain.active').removeClass('active');

            if (el.parents('.table-row').length) {
                el.parents('.table-row').addClass('ajaxActive');
            } else {
                el.addClass('ajaxActive');
            }
            if (el.parents('.link-contain').length) {
                el.parents('.link-contain').addClass('active');
            }

            // == Allow a Loader Disabled Class == //
            if (el.parents('.panel').hasClass('disableLoader')) {
                window.location = location;
                return;
            }

            // == Fetch Data == //
            this.viewLoader(location, false, urlHistory);
        }
    },
    // It's good to clean up event listeners before a component is destroyed.
    beforeDestroy () {
        this.$eventHub.$off('viewLoader', this.viewLoader);
        this.$eventHub.$off('eventLoader', this.eventLoader);
    }
};